// extracted by mini-css-extract-plugin
export default {"caption":"TableCaption_caption__YCO2V"};